import type { components } from '@/api/qraft/schema';
import type { LanguageCode } from '~/types/congregationGroupTypes';

type ApiLanguage = components['schemas']['Language'];

const API_TO_LOCALE: Record<ApiLanguage, LanguageCode> = {
  EN: 'en',
  ES: 'es',
  FR: 'fr',
  PT_BR: 'pt-br',
};

const LOCALE_TO_API: Record<LanguageCode, ApiLanguage> = {
  en: 'EN',
  es: 'ES',
  fr: 'FR',
  'pt-br': 'PT_BR',
};

export function apiLanguageToLocale(language: ApiLanguage): LanguageCode {
  return API_TO_LOCALE[language];
}

/**
 * The reverse, for the surfaces that pass an explicit `language` query parameter.
 *
 * The public course directory is one: legacy renders and caches it in the
 * INTERFACE language, not the viewer's stored account language — cache key
 * `wbs_series_directory_html_cache?{$current_language}`
 * (`modules/series/template-functions.php:16,24`) — and has no per-user switch.
 */
export function localeToApiLanguage(locale: string): ApiLanguage {
  return LOCALE_TO_API[locale as LanguageCode] ?? 'EN';
}
